<template>
  <div>
    <v-card>
      <v-system-bar dark color="grey darken-1" height="50" class="mb-4">
        <v-btn
          outlined
          small
          fab
          dark
          class="transparent"
          @click.stop="$router.push('/')"
        >
          <v-icon>mdi-arrow-left-circle</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        {{ $route.params.id }} {{ $route.query.displayName }}
        <v-spacer></v-spacer>

        <v-btn
          outlined
          small
          fab
          dark
          class="transparent"
          @click.stop="$router.go(-1)"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-system-bar>

      <v-card-text>
        <template>
          <v-card>
            <v-tabs v-model="tab" centered icons-and-text show-arrows>
              <v-tabs-slider></v-tabs-slider>

              <v-tab href="#groupe">
                Groupes
                <v-icon>mdi-account-group</v-icon>
              </v-tab>

              <v-tab href="#horsgroupe">
                Hors groupe
                <v-icon>mdi-account</v-icon>
              </v-tab>

              <v-tab href="#formationdemasse">
                Formations
                <v-icon>mdi-school</v-icon>
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item key="groupe" value="groupe">
                <v-card flat>
                  <v-card-text>
                    <v-card flat class="mb-4">
                      <v-list two-line subheader>
                        <v-list-item
                          v-for="(item, index) in setListeGroupe()"
                          :key="index"
                          @click="detailsGroupe(item)"
                        >
                          <v-list-item-content>
                            <v-list-item-title
                              v-html="item.nom_groupe"
                            ></v-list-item-title>
                            <v-list-item-subtitle>
                              {{ item.ll_commune }} -
                              {{ item.ll_fokontany }}
                            </v-list-item-subtitle>
                            <v-list-item-subtitle>
                              {{ item.village }}
                            </v-list-item-subtitle>
                          </v-list-item-content>

                          <v-list-item-action>
                            <v-btn icon @click="detailsGroupe(item)">
                              <v-icon color="grey lighten-1"
                                >mdi-chevron-right</v-icon
                              >
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </v-card></v-card-text
                  >
                </v-card>
              </v-tab-item>
              <v-tab-item key="horsgroupe" value="horsgroupe">
                <v-card flat>
                  <v-card-text>
                    <v-card flat class="mb-4">
                      <!-- <v-card-title>Membres hors Groupes</v-card-title> -->
                      <v-card-text>
                        <membresHorsGroupe
                          :projet="$route.params.id"
                          :animateur="$route.query.uid"
                        />
                      </v-card-text> </v-card
                  ></v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item key="formationdemasse" value="formationdemasse">
                <v-card flat>
                  <v-card-text
                    ><v-card flat class="mb-4">
                      <!--   <v-card-title>Formations de masse</v-card-title> -->
                      <v-card-text>
                        <formationDeMasseDialog
                          :projet="$route.params.id"
                          :animateur="$route.query.uid"
                        />
                      </v-card-text> </v-card
                  ></v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </template>
      </v-card-text>

      <v-card-actions>
        <Navigation :elements="SuperviseurNavigation" />
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  components: {
    Navigation: require("@/components/Navigation.vue").default,
    Widget: require("@/components/Widget.vue").default,
    groupeDialog: require("@/components/groupes/groupeDialog.vue").default,
    formationDeMasseDialog: require("@/components/superviseur/formationDeMasseDialog.vue")
      .default,
    dotationDialog: require("@/components/superviseur/dotationDialog.vue")
      .default,
    membresHorsGroupe: require("@/components/groupes/membresHorsGroupe.vue")
      .default,
  },
    data() {
    return {
      tab: "groupe",
    };
  },
  created() {
    var objet = { userId: this.$route.query.uid, project: this.$route.params.id };
    this.GetGroupesDeSuperviseur(objet);
    //this.GetGroupesDeSuperviseur(this.$route.query.uid);
  },
  methods: {
    setListeGroupe() {
      let liste = _.filter(this.groupesDeSuperviseur, {
        projets: [{ ll_programme: this.$route.params.id }],
      });
      return liste;
    },
    detailsGroupe(item) {
      /* this.$router.push({ path: `/detailsGroupe/${item}` });*/

      this.$router.push({
        path: `/detailsGroupe/${item.id}`,
        query: { projet: this.$route.params.id },
      });
    },
    ...mapActions({
      GetGroupesDeSuperviseur: "Groupes/GetGroupesDeSuperviseur",
    }),
  },
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
      groupesDeSuperviseur: (state) => state.Groupes.groupesDeSuperviseur,
      SuperviseurNavigation: (state) => state.Navigation.SuperviseurNavigation,
    }),
  },
};
</script>

<style lang="scss" scoped></style>
